export enum PAGE_NAME {
    PROFILE = "PROFILE",
    MESSENGER = "MESSENGER",
    ACTIVITY = "ACTIVITY",
    BOOKING = "BOOKING",
    OUTING = "OUTING",
}